import EmailTabContentComponent from 'email-notification-templates/components/email-notification-tab/components/tab-content/tab-content-component';
import template from './tab-content.html';

export default class SmsTabContentComponent extends EmailTabContentComponent {
  constructor() {
    super();
    this.template = template;
  }
}



// WEBPACK FOOTER //
// ./src/modules/sms/components/sms-notification-templates/components/sms-notification-tab/components/tab-content/tab-content-component.js